import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { TokenDataProvider } from "@/context/TokenDataContext";
import { initLenis, scrollToId } from "@/lib/lenis";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SpaceBackground } from "@/components/SpaceBackground";
import { Header } from "@/components/Header";
import { TokenBar } from "@/components/TokenBar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Roadmap } from "@/components/Roadmap";
import { EcosystemSection } from "@/components/EcosystemSection";
import { PortfoliosSection } from "@/components/PortfoliosSection";
import { CommunityFooter } from "@/components/CommunityFooter";
import { DevPanel } from "@/components/DevPanel";
import { UnlockCelebration } from "@/components/UnlockCelebration";
import { LoadingScreen } from "@/components/LoadingScreen";
import { BullTargetCursor } from "@/components/cursor/BullTargetCursor";
import "@/styles/neon-typography.css";
import BuyPage from "@/pages/BuyPage";
import { DexScreenerChart } from "@/components/market/DexScreenerChart";

const HOME_TITLE = document.title;

function AppContent() {
  const { pathname, hash } = useLocation();
  const isBuy = /^\/buy\/?$/.test(pathname);
  useEffect(() => initLenis(), []);
  useEffect(() => {
    document.title = isBuy ? "GET $KBULL | KINGBULLISH" : HOME_TITLE;
    const timer = setTimeout(() => {
      if (!isBuy && hash) scrollToId(hash.slice(1));
      else window.scrollTo({ top: 0, behavior: "instant" });
    }, 100);
    return () => clearTimeout(timer);
  }, [pathname, hash, isBuy]);

  return (
    <ErrorBoundary>
      <MotionConfig reducedMotion="user">
        <TokenDataProvider>
          <div className="kb-root relative min-h-screen bg-ink text-white font-body" data-testid={isBuy ? "kingbullish-buy-page" : "kingbullish-homepage"}>
            <a
              href="#main"
              className="skip-link"
              onClick={(e) => { e.preventDefault(); scrollToId("main"); }}
              data-testid="skip-to-content"
            >
              SKIP TO CONTENT
            </a>
            {!isBuy && <SpaceBackground />}
            <div className="grain" aria-hidden="true" />
            <Header />
            <main id="main" className="relative z-10">
              {isBuy ? <BuyPage /> : <>
              <TokenBar />
              <Hero />
              <Marquee />
              <DexScreenerChart />
              <Roadmap />
              <EcosystemSection />
              <PortfoliosSection />
              </>}
            </main>
            {!isBuy && <><CommunityFooter /><DevPanel /><UnlockCelebration /></>}
            <Toaster theme="dark" position="bottom-center" toastOptions={{ className: "kb-toast" }} />
            {!isBuy && <LoadingScreen />}
            <BullTargetCursor />
          </div>
        </TokenDataProvider>
      </MotionConfig>
    </ErrorBoundary>
  );
}

export default function App() {
  return <BrowserRouter><AppContent /></BrowserRouter>;
}
